import { clean } from 'ContentComponents/components/cmv2/sanitize/sanitize';
import { configureSanitize } from 'ContentComponents/components/cmv2/sanitize/sanitizeConfig';
import { PREVIEW_CLASSNAME } from '../../../constants/GlobalStyles';
import { jsx as _jsx } from "react/jsx-runtime";
const Sanitize = configureSanitize();
export const GlobalStylesPreview = ({
  previewHtml
}) => {
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx("div", {
      className: PREVIEW_CLASSNAME,
      dangerouslySetInnerHTML: {
        __html: clean(previewHtml, Sanitize.Config.PREVIEW, [])
      }
    })
  );
};